import React from 'react';
import ErrorPage from './ErrorPage';

const UnauthorizedPage = () => (
  <ErrorPage
    code="401"
    tone="warn"
    eyebrow="Authentication Required"
    title="You need to be signed in for this."
    message="Connect your wallet and sign the login message to access this area. Your wallet remains in your control — Phonestream never holds private keys."
    primaryCta={{ label: 'Connect wallet', to: '/' }}
    secondaryCta={{ label: 'Browse the store', to: '/store' }}
  />
);

export default UnauthorizedPage;
